module.exports = __webpack_public_path__ + "static/media/CTLI_15-444w.b8d0550e.jpg";